import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Route as V2RouteRaw } from '@uniswap/v2-sdk';
import { Route as V3RouteRaw } from '@uniswap/v3-sdk';
export var V3Route = /*#__PURE__*/function (_V3RouteRaw) {
  _inherits(V3Route, _V3RouteRaw);

  var _super = _createSuper(V3Route);

  function V3Route() {
    _classCallCheck(this, V3Route);

    return _super.apply(this, arguments);
  }

  return _createClass(V3Route);
}(V3RouteRaw);
export var V2Route = /*#__PURE__*/function (_V2RouteRaw) {
  _inherits(V2Route, _V2RouteRaw);

  var _super2 = _createSuper(V2Route);

  function V2Route() {
    _classCallCheck(this, V2Route);

    return _super2.apply(this, arguments);
  }

  return _createClass(V2Route);
}(V2RouteRaw);
export var SwapToRatioStatus;

(function (SwapToRatioStatus) {
  SwapToRatioStatus[SwapToRatioStatus["SUCCESS"] = 1] = "SUCCESS";
  SwapToRatioStatus[SwapToRatioStatus["NO_ROUTE_FOUND"] = 2] = "NO_ROUTE_FOUND";
  SwapToRatioStatus[SwapToRatioStatus["NO_SWAP_NEEDED"] = 3] = "NO_SWAP_NEEDED";
})(SwapToRatioStatus || (SwapToRatioStatus = {}));
/**
 * Provides functionality for finding optimal swap routes on the Uniswap protocol.
 *
 * @export
 * @abstract
 * @class IRouter
 */


export var IRouter = /*#__PURE__*/_createClass(function IRouter() {
  _classCallCheck(this, IRouter);
});
export var ISwapToRatio = /*#__PURE__*/_createClass(function ISwapToRatio() {
  _classCallCheck(this, ISwapToRatio);
});